import React from 'react';
import PropTypes from 'prop-types';
import { OTHER_ALIAS } from '../../../constants';
import { getItemLink, getItemName } from '../../utils';
import Badge from '../../Badge';

const Card = ({ item, source }) => {
    const { size, urlParams, image, alias, type, badge } = item;
    if (alias === OTHER_ALIAS) { return null; }
    return (
        <a className={`box ${size}`} href={getItemLink(type, urlParams, source)}>
            <div>
                <img src={image}></img>
                <div className="text">
                    <span className="item-title">{getItemName(alias, type, urlParams)}</span>
                    <Badge badge={badge}/>
                </div>
            </div>
        </a>
    );
};

Card.propTypes = {
    item: PropTypes.object,
    source: PropTypes.string
};

export default Card;